import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import MarkdownRenderer from '../components/MarkdownRenderer.jsx';
import { getPostBySlug } from '../data/posts.js';

function PostDetail() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(Boolean(post));
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadPost = async () => {
      if (!post) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(post.markdownPath);
        if (!response.ok) {
          throw new Error('Yazi icerigi yuklenemedi.');
        }
        const markdown = await response.text();

        if (isMounted) {
          setContent(markdown);
          setError('');
        }
      } catch (fetchError) {
        if (isMounted) {
          setError(fetchError.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPost();

    return () => {
      isMounted = false;
    };
  }, [post]);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Header />
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        {!post && (
          <Card sx={{ borderRadius: '18px', border: '1px solid #e2e8f0', boxShadow: 'none' }}>
            <CardContent sx={{ p: 3.5 }}>
              <Stack spacing={2}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a' }}>
                  Yazi bulunamadi
                </Typography>
                <Typography sx={{ color: '#475569' }}>Bu slug icin bir yazi tanimi yok. `src/data/posts.js` dosyasina yeni bir kayit ekleyebilirsin.</Typography>
                <Button component={Link} to="/posts" variant="contained" sx={{ textTransform: 'none', width: 'fit-content', backgroundColor: '#0f172a' }}>
                  Tum yazilara don
                </Button>
              </Stack>
            </CardContent>
          </Card>
        )}

        {post && (
          <Stack spacing={2.5}>
            <Button component={Link} to="/posts" variant="text" sx={{ textTransform: 'none', width: 'fit-content', color: '#334155' }}>
              {'<- Yazilar listesine don'}
            </Button>

            <Card sx={{ borderRadius: '18px', border: '1px solid #e2e8f0', boxShadow: 'none' }}>
              <CardContent sx={{ p: { xs: 2.5, md: 4 } }}>
                <Stack spacing={1.5}>
                  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                    <Chip label={post.category} size="small" sx={{ backgroundColor: '#e2e8f0', color: '#1e293b', fontWeight: 700 }} />
                    <Chip label={post.readTime} size="small" sx={{ backgroundColor: '#f1f5f9', color: '#475569', fontWeight: 700 }} />
                  </Stack>
                  <Typography variant="h3" sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, fontWeight: 800, lineHeight: 1.2, color: '#0f172a' }}>
                    {post.title}
                  </Typography>
                  <Typography sx={{ color: '#64748b' }}>{post.date}</Typography>
                </Stack>
              </CardContent>
            </Card>

            <Card sx={{ borderRadius: '18px', border: '1px solid #e2e8f0', boxShadow: 'none' }}>
              <CardContent sx={{ p: { xs: 2.5, md: 4 } }}>
                {loading && <Typography sx={{ color: '#475569' }}>Yazi yukleniyor...</Typography>}
                {!loading && error && <Typography sx={{ color: '#b91c1c' }}>{error}</Typography>}
                {!loading && !error && <MarkdownRenderer source={content} />}
              </CardContent>
            </Card>
          </Stack>
        )}
      </Container>
    </Box>
  );
}

export default PostDetail;


